import React from 'react'
import './Modal.scss'

export default function Modal({
  children,
  title,
  content,
  isOpen,
  onConfirm,
  onCancel
}) {
  if (!isOpen) return null

  return (
    <div className='modal-overlay'>
      <div className='modal-content'>{children}</div>
    </div>
  )
}
